import React, {useContext} from 'react';
import {AppContext} from '@app/context/context';
import block from 'bem-cn-lite';
import {ToasterComponent, ToasterProvider} from '@gravity-ui/uikit';
import {Navigate, Outlet} from 'react-router-dom';
import {MainSideBar} from '@components/MainSideBar';
import {Header} from '@components/Header';

import './AuthWrapper.scss';

const b = block('auth-wrapper');

export const AuthWrapper: React.FC = () => {
    const context = useContext(AppContext);

    function isExpired() {
        const exp = context.state.user?.exp;
        if (!exp) return undefined;

        return exp < new Date().getTime() / 1000;
    }

    if (!context.state.token) {
        return <Navigate to="/" />;
    }

    if (isExpired()) {
        context.emit('logout', {redirectTo: '/'});
    }

    return (
        <ToasterProvider>
            <div className={b()}>
                <div className={b('sidebar')}>
                    <MainSideBar />
                </div>

                <div className={b('container')}>
                    <div className={b('header')}>
                        <Header />
                    </div>

                    <div className={b('content')} id="main-content">
                        <Outlet />
                    </div>
                </div>
            </div>
            <ToasterComponent />
        </ToasterProvider>
    );
};
